/*
 * Copyright © 2017-Present, The Freshwater Trust, all rights reserved.
 */

import {useMemo} from "react";
import {useFetchServiceModel} from "./ServiceHooks";
import {service as OrganizationService} from "../Services/OrganizationService";

const defaultOrganizationProfileImage = "/img/defaultProfilePicture.png";

export const useOrganizationProfileImage = (providedOrganization) => {
    const { organizationId = null } = providedOrganization ?? {};
    
    const organization = useFetchServiceModel(OrganizationService, organizationId, providedOrganization);
    
    return useMemo(() => {
        return organization?.image ?? defaultOrganizationProfileImage;
    }, [organization?.image]);
}
